//Comentario necesario para codificación en UTF-8, ver Inc6743
"use strict";

(function() {
	angular.module('pphhApp')
		.factory("MyDownloadService", ["$http", MyDownloadServiceFactory]);

	function MyDownloadServiceFactory($http) {
		return {
			getPendingTasks: function(moduleName) {
				return $http.get("/myDownload/tasks?wm=" + moduleName);
			}
		};
	}

})();
